import { axiosInstance, axiosInstanceExporters } from "./";

const importersList = async ({ params }) =>
  await axiosInstance.get("/api/User/GetImporters", {
    params,
    paramsSerializer: { indexes: null }
  });

const exportersList = async ({ params }) =>
  await axiosInstance.get("/api/User/GetExporters", {
    params,
    paramsSerializer: { indexes: null }
  });

const getImporterDetails = async ({ id }) =>
  await axiosInstance.get(`/api/User/ViewImporter/${id}`);

const getExporterCompanyDetails = async ({ params }) =>
  await axiosInstanceExporters.get(`/api/Company/GetById`, {
    params
  });

const getExporterContactInfo = async (id) =>
  await axiosInstanceExporters.get(`/api/User/GetById`, {
    params: { id }
  });

const getExporterVerificationInfo = async ({ params }) =>
  await axiosInstance.get(
    `/api/CompanyBusinessVerificationRequest/GetExporterVerficationSubscriptionData`,
    { params }
  );

const getExporterTransactionsList = async ({ params }) =>
  await axiosInstanceExporters.get(
    "/api/Transaction/GetUserTransactions",
    {
      params
    }
  );

const getCompanyContactInfo = async ({ id }) =>
  await axiosInstanceExporters.get(
    `/api/Company/GetCompanyContactInfo/${id}`
  );

const getExporterAccountInfo = async ({ id }) =>
  await axiosInstance.get(`/api/User/View/${id}`);

const blockImporter = async ({ data }) =>
  await axiosInstance.put("/api/User/Block", data);

const unblockImporter = async ({ data }) =>
  await axiosInstance.put("/api/User/Unblock", data);

const combinedList = async ({ params }) =>
  await axiosInstance.get("/api/User/GetBoth", {
    params,
    paramsSerializer: { indexes: null }
  });

export {
  importersList,
  exportersList,
  getImporterDetails,
  getExporterCompanyDetails,
  getExporterContactInfo,
  getExporterVerificationInfo,
  getExporterTransactionsList,
  getCompanyContactInfo,
  getExporterAccountInfo,
  blockImporter,
  unblockImporter,
  combinedList
};
